import React from 'react';

type HTMLTag = keyof JSX.IntrinsicElements;

interface SanitizeProps extends Omit<React.HTMLAttributes<HTMLElement>, 'as'> {
  as?: HTMLTag;
  children: React.ReactNode;
  hidden?: boolean; // For data-openreplay-hidden instead of data-openreplay-sanitize
}

export const Sanitize: React.FC<SanitizeProps> = ({
  as: Component = 'span',
  children,
  hidden = false,
  className,
  ...rest
}) => {
  return React.createElement(
    Component,
    {
      className,
      'data-openreplay-hidden': hidden ? true : undefined,
      'data-openreplay-sanitize': !hidden ? true : undefined,
      ...rest,
    },
    children,
  );
};
